<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--  素材管理->案例库-->
  <base-page-component :has-back="false" :has-nav="false" nav-title="电子书">
    <div style="background-color: #F4F8FF;height: 100%">
      <div class="bg-white m-auto h-full position-relative">

        <div class="flex a-center h-60 m-h-25">
          <Button @click="groupManager.show = true" class="m-r-10" type="primary">分类管理</Button>
          <Button @click="createEbook" class="m-r-10" type="primary">新增电子书</Button>

          <class-choose-widget :gutter="10" :srcType="3" @dataChange="onClassGroupChange" leftPlaceholder="电子书分类"
                               rightPlaceholder="电子书分组"
                               style="width: 300px;">

          </class-choose-widget>
          <Button class="m-l-15" type="primary"
                  v-clipboard:copy="objChange.linkurl"
                  v-clipboard:error="onError"
                  v-clipboard:success="copy">复制链接
          </Button>

          <Input class="m-l-15" placeholder="电子书名" style="width: 240px"/>
          <Button class="m-l-15">搜索</Button>

          <div class="flex flex-1  h-full a-center j-end">
            <Button @click="delMulti">批量删除</Button>
            <!--            <Button type="primary" class="m-l-15" @click="toUploadPic">上传图片</Button>-->
          </div>
        </div>

        <div class="m-h-25 ">
          <Table :columns="columns" :data="dataList" :height="tableHeight" ref="table">

            <template v-slot:content="{row,index}">
              <div class="flex a-center">
                <img class="w-40 h-30 flex-shrink-0 m-v-15"
                     src="../../../assets/common/ic_default_img.png"/>
                <div class="m-l-10 lin1" style="text-align: left">
                  {{ row.content }}
                </div>
              </div>
            </template>
            <template v-slot:copy="{row,index}">
              <div class="flex a-center">
                <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.url"
                     v-clipboard:error="onError"
                     v-clipboard:success="copy"/>

              </div>
            </template>
            <template v-slot:link="{row,index}">
              <div class="flex a-center">
                <div class="flex-1 text-left">
                  {{ row.url }}
                </div>
                <!--                <i class=" m-h-15 icon-copy fs-20" style="color: #1472FF;cursor: pointer"-->
                <!--                   v-clipboard:copy="row.url"-->
                <!--                   v-clipboard:error="onError"-->
                <!--                   v-clipboard:success="copy"/>-->

              </div>
            </template>

            <template v-slot:operation="{row,index}">
              <div class="flex a-center j-center">
                <!--                <i class="icon-watch fs-16 m-r-10" style="color: #1472FF;cursor: pointer"/>-->
                <!--                <i class="icon-edit fs-16 m-l-10 m-r-10" style="color: #4CAF50;cursor: pointer"-->
                <!--                   @click="editItem(row,index)"></i>-->
                <!--                <i class="icon-delete fs-16 m-l-10" style="color: #E53935;cursor: pointer"-->
                <!--                   @click="delItem(row,index)"></i>-->
                <span @click="editItem(row,index)" class="m-r-20"
                      style="cursor: pointer;color: #3B80FF">编辑</span>
                <span @click="delItem(row,index)"
                      style="cursor: pointer;color: red">删除</span>
              </div>
            </template>
          </Table>

          <Page :current="pageNum" :page-size="pageSize" :total="totalPage"
                class="m-t-10 p-b-10" show-total/>
        </div>
      </div>
    </div>

    <Modal
      :closable="false"
      class="modal-setting"
      class-name="vertical-center-modal"
      v-model="groupManager.show"
      width="640px"
    >
      <p class="text-center" slot="header">
        <span>{{ groupManager.title }}</span>
      </p>

      <div class="flex a-center j-center" style="width: 600px;height: 360px">
        <class-group-setting-widget2 :objInfo="objInfo"
                                     :srcType="3"
                                     class="w-full h-full">
        </class-group-setting-widget2>
      </div>

    </Modal>
  </base-page-component>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import classGroupSettingWidget2 from '@/components/common/ClassGroupSettingWidget2'
import ClassChooseWidget from '../../../components/common/ClassChooseWidget'


export default {
  name: 'EBook',
  components: {
    ClassChooseWidget,
    BasePageComponent,
    classGroupSettingWidget2
  },
  watch: {
    ObjParams: {
      handler (newValue) {
        this.classList.splice(0, this.classList.length)
        newValue.classifyDatas.forEach((item, index) => {
          //组件里面第一个都给删掉了
          if (index > 0) {
            this.classList.push({
              'id': item.id,
              'name': item.name
            })
          }
        })

        this.groupList.splice(0, this.groupList.length)
        let index = newValue.groupList.findIndex(item => item.classId === this.selectedClass)
        newValue.groupList[index].data.forEach((item, index) => {
          //组件里面第一个都给删掉了
          if (index > 0) {
            this.groupList.push({
              'id': item.id,
              'name': item.name
            })
          }
        })
      },
      deep: true,
      immediate: true,
    }
  },
  data () {
    return {
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      tableHeight: 620,
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      objInfo: {
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },

      totalPage: 99,
      pageSize: 20,
      pageNum: 1,

      ////////////////////////////////class group//////////////////////////////////////////////////
      groupManager: {
        title: '分类管理',
        show: false,
      },

      classList: [],
      groupList: [],
      selectedClass: 1,
      selectedGroup: 2,
      ObjParams: {
        'classifyDatas': [
          {
            'desc': '',
            'icon': '',
            'id': 0,
            'isDefault': 0,
            'link': {
              'link': 'https://tradeapp.laodao.co/document/handbookCategory.html?contentType=24&id=2421',
              'title': '000'
            },
            'name': 'ttt3',
            'sort': 3,
            'type': 3
          },
          {
            'id': 1,
            'isDefault': 1,
            'name': '默认分类',
            'type': 3
          },
          {
            'id': 2,
            'isDefault': 0,
            'name': '222',
            'type': 3
          }],
        'groupList': [
          {
            'classId': 0,
            'data': [
              {
                'categoryId': 0,
                'id': 3154,
                'isDefault': 0,
                'name': 'g2',
                'sort': 2,
                'type': 3
              }, {
                'categoryId': 0,
                'id': 3153,
                'isDefault': 0,
                'name': 'g1',
                'sort': 3,
                'type': 3
              }, {
                'categoryId': 0,
                'id': 3150,
                'isDefault': 1,
                'name': '默认分组',
                'sort': 4,
                'type': 3
              }
            ],
          },
          {
            'classId': 1,
            'data': [
              {
                'categoryId': 1,
                'id': 1,
                'isDefault': 1,
                'name': '000',
                'sort': 2,
                'type': 3
              }, {
                'categoryId': 1,
                'id': 2,
                'isDefault': 1,
                'name': '默认分组',
                'type': 3
              }, {
                'categoryId': 1,
                'id': 3,
                'isDefault': 0,
                'name': '222',
                'type': 3
              }
            ],
          },
          {
            'classId': 2,
            'data': [
              {
                'categoryId': 2,
                'desc': '',
                'id': 1,
                'isDefault': 0,
                'name': 'g2',
                'type': 3
              }, {
                'categoryId': 2,
                'desc': '',
                'id': 2,
                'isDefault': 1,
                'name': '默认分组',
                'type': 3
              }, {
                'categoryId': 2,
                'icon': '',
                'id': 3,
                'isDefault': 0,
                'name': 'group-2',
                'type': 3
              }
            ],
          },
        ]
      },
      ////////////////////////////////class group//////////////////////////////////////////////////


      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center',
        }, {
          title: '电子书名称',
          slot: 'content',
          width: 400,
          align: 'center',
        }, {
          title: '分类',
          key: 'clazz',
          width: 110,
          align: 'center',
        }, {
          title: '分组',
          key: 'group',
          width: 120,
          align: 'center',
        }, {
          title: '修改时间',
          key: 'modifyTime',
          width: 180,
          align: 'center',
        }, {
          title: '修改人',
          key: 'modifyBy',
          align: 'center',
          width: 120,
        }, {
          title: '链接',
          slot: 'link',
          minWidth: 400,
          align: 'center',
        }, {
          title: '复制',
          slot: 'copy',
          width: 100,
          align: 'left'
        }, {
          title: '操作',
          slot: 'operation',
          width: 150,
          align: 'center',
        }
      ],
      dataList: [
        {
          id: '1',
          clazz: '分类1',
          group: '分组1',
          content: '标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1',
          duration: '3:23',
          modifyBy: 'zgh',
          modifyTime: '2022-10-10 12:00:00',
          isChecked: false,
          url: 'https://baidu.com//test/testtesttesttest/testtesttesttest/test.mp4'
        }, {
          id: '2',
          clazz: '分类2',
          group: '分组2',
          content: '标题2',
          duration: '13:23',
          modifyBy: 'zgh',
          modifyTime: '2022-10-10 12:00:00',
          url: 'https://baidu.com//test/testtesttesttest/testtesttesttest/test.mp4'

        }, {
          id: '3',
          clazz: '分类3',
          group: '分组3',
          content: '标题3',
          duration: '23:23',
          modifyBy: 'zgh',
          modifyTime: '2022-10-10 12:00:00',
          url: 'https://baidu.com//test/testtesttesttest/testtesttesttest/test.mp4'
        }, {
          id: '4',
          clazz: '分类4',
          group: '分组4',
          content: '标题4',
          duration: '7:23',
          modifyBy: 'zgh',
          modifyTime: '2022-10-10 12:00:00'
        }
      ]
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    createEbook () {
      this.$router.push('/ebookDetail')
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    delItem (row, index) {
      const content = '<p>确定要删除吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          this.dataList.splice(index, 1)
        },
        onCancel: () => {
        }
      })
    },
    editItem (row, index) {
      this.$router.push('/editebook')
    },
    //无请求,模拟删除
    delMulti () {
      let selections = this.$refs.table.getSelection()
      if (selections.length === 0) {
        this.$Message.info('没有选中电子书')
        return
      }
      const content = '<p>确定要删除吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let selections = this.$refs.table.getSelection()
          selections.forEach(item => {
            let index = this.dataList.findIndex(item2 => item2.id === item.id)
            if (index > -1) {
              this.dataList.splice(index, 1)
            }
          })
        },
        onCancel: () => {
        }
      })
    },

    ////////////////////////////////class group//////////////////////////////////////////////////
    addGroups (classId, groupeName) {
      let index = this.ObjParams.groupList.findIndex(item => item.classId === classId)
      let groupListItem = this.ObjParams.groupList[index]
      groupListItem.data.push({
        'categoryId': classId,
        'id': 3150,
        'isDefault': 0,
        'name': groupeName,
        'type': 3
      })
      return new Promise(((resolve, reject) => {
        resolve(groupListItem.data)
      }))
    },
    classadd (value) {
      console.log('classadd')
      return new Promise(((resolve, reject) => {
        this.addClassify = value
        let id = Math.ceil(Math.random() * 1000)
        new Promise((resolve, reject) => {
          let classifyDatas = this.ObjParams.classifyDatas
          let dd = {
            'desc': '',
            'id': id,
            'isDefault': 0,
            'name': value,
            'type': 3
          }
          classifyDatas.push(dd)
          resolve(classifyDatas)
          this.ObjParams.groupList.push(
            {
              'classId': id,
              'data': [
                {
                  'categoryId': id,
                  'id': 3154,
                  'isDefault': 0,
                  'name': 'g2',
                  'sort': 2,
                  'type': 3
                }, {
                  'categoryId': id,
                  'id': 3153,
                  'isDefault': 1,
                  'name': '默认分组',
                  'type': 3
                }
              ],
            },
          )
        }).then(res => {
          this.$Message.success('添加分类成功！')
          this.classifyDatas = res
          resolve(res)
          this.addClassify = ''
        })
      }))
    },
    // 添加分类显示框
    onAddClassify () {
      this.addClassifyShow = !this.addClassifyShow
    },
    classchange (data) {
      return new Promise((resolve, reject) => {
        resolve(this.ObjParams.classifyDatas)
      })
    },
    deleteClass (data) {
      return new Promise((resolve, reject) => {
        let classifyDatas = this.ObjParams.classifyDatas
        let index = classifyDatas.findIndex(item => item.id === data.id)
        classifyDatas.splice(index, 1)
        resolve(classifyDatas)
      })
    },
    deleteGroup (data) {
      return new Promise(((resolve, reject) => {
        let groupList = this.ObjParams.groupList
        let index = groupList.findIndex(item => item.classId === data.categoryId)
        let groupItemList = groupList[index].data
        let index2 = groupItemList.findIndex(item => item.id === data.id)
        groupItemList.splice(index2, 1)

        resolve(groupItemList)
        this.$Message.success(res.msg)
      }))
    },
    getGroupData (id) {
      return new Promise(((resolve, reject) => {
        let groupList = this.ObjParams.groupList
        let index = groupList.findIndex(item => item.classId === id)
        if (index > -1) {
          resolve(groupList[index].data)
        } else {
          resolve([])
        }
      }))
    },

    renameGroup (data) {
      console.log('renameGroup')
      return new Promise((resolve, reject) => {
        resolve(data)
        this.$Message.success(res.msg)
      })
    },
    onSelectClass (value) {
      let groupList = this.ObjParams.groupList
      let index = groupList.findIndex(item => item.classId === value)
      this.groupList.splice(0, this.groupList.length)
      groupList[index].data.forEach((item, index) => {
        if (index > 0) {
          this.groupList.push({
            'id': item.id,
            'name': item.name,
          })
        }
      })
      this.selectedGroup = this.groupList[0].id
    },
    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      this.tablePage.currentPage = 1
      // this.getPicListData()
    },
  }
}
</script>

<style lang="scss" scoped>
  .lin1 {
    color: #333;
    //max-width: 600px;
    font-size: 13px;
    line-height: 20px;
    //height: 40px;
    //margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 1; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }

  .modal-setting ::v-deep {

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }
</style>
